import { useMutation } from "@apollo/client";

import { ProtocolEditRoute_VisitCreateDocument, ProtocolEditRoute_VisitCreateMutation } from "../mutations.generated";
import { PROTOCOL_GET_BY_ID } from "./useProtocolEditRoute_GetById";

type AddProtocolVisitParams = {
    addVisit: () => Promise<ProtocolEditRoute_VisitCreateMutation | null | undefined>;
    loading: boolean;
    error: Error | undefined;
};

export default function useProtocolVisitCreate(protocolId: string): AddProtocolVisitParams {
    const [addVisit, { loading, error }] = useMutation(ProtocolEditRoute_VisitCreateDocument, {
        refetchQueries: [PROTOCOL_GET_BY_ID],
        awaitRefetchQueries: true,
    });

    return {
        addVisit: () =>
            addVisit({
                variables: {
                    input: { protocolId },
                },
            }).then(result => result.data),
        loading,
        error,
    };
}
